import React from 'react';
import { Helmet } from 'react-helmet';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import getEventsQuery from '../../../graphql/queries/getEvents.graphql';
import { autoOptimizeImage } from 'utils/functions';
import styled from 'styled-components';
import Event from './Event';

const EventsListContainer = styled.div`
  min-height: 100vh;
`;

const propTypes = {
  className: PropTypes.string,
};

function EventsList({ className }) {
  const { data } = useQuery(getEventsQuery, {
    variables: {
      filters: {
        sortBy: 'event_date',
        sortDirection: 'ascending',
      },
    },
  });

  const events = get(data, 'events.items', []);

  if (!events) {
    return null;
  }

  const datedEvents = [];
  const noDateEvents = [];
  events.forEach((event) => {
    if (event.eventDate) {
      datedEvents.push(event);
    } else {
      noDateEvents.push(event);
    }
  });

  const allEvents = [...datedEvents, ...noDateEvents];

  return (
    <>
      <Helmet>
        {allEvents.length > 0 && allEvents[0]?.eventImage?.[0]?.eventImage?.url && (
          <link
            rel="preload"
            as="image"
            href={autoOptimizeImage(allEvents[0].eventImage[0].eventImage.url, true)}
          />
        )}
      </Helmet>
      <EventsListContainer className={className}>
        {allEvents.map((eventItem, index) => (
          <Event eventItem={eventItem} key={`event-${index}`} />
        ))}
      </EventsListContainer>
    </>
  );
}

EventsList.propTypes = propTypes;

export default React.memo(EventsList);